<template>
  <b-container>
    <Header
      v-if="listExist('featured_niches', getExperience)"
      :items="list('featured_niches', getExperience)"
      :type="type"
    >
      {{ $t(`main.${type}.header.header`) }}
    </Header>
    <div class="title text-center mt-5">
      <h2 class="grouper-subtitle">{{ $t(`main.${type}.content.text3`) }}</h2>
    </div>
    <div class="w-100">
      <Grid :group="niches" :type="type" />
      <div
        v-if="!enough"
        v-infinite-scroll="getData"
        infinite-scroll-disabled="loadingNiche"
        class="d-flex w-100 justify-content-center align-items-center"
      >
        <Loading />
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Header from '@/components/Groupers/PageHeader';
import Grid from '@/components/Groupers/Grid';
import Loading from 'UI/Loading';
export default {
  components: {
    Header,
    Grid,
    Loading
  },
  data() {
    return {
      enough: false,
      addItems: false
    };
  },
  computed: {
    ...mapGetters('niches', ['getNichesName', 'getTopicsName']),
    ...mapGetters('listings', ['list', 'listExist']),
    ...mapGetters('experience', ['isDesignActive', 'getExperience']),
    ...mapState('niches', ['niches', 'loadingNiche', 'nichesCurrentPage', 'nichesTotalPages']),
    type() {
      return this.isDesignActive ? this.getTopicsName : this.getNichesName;
    }
  },
  methods: {
    async getData() {
      if (this.nichesCurrentPage < this.nichesTotalPages && !this.loadingNiche) {
        this.addItems = true;
        await this.$store.dispatch('niches/LOAD_NICHES', { page: this.nichesCurrentPage + 1 });
        this.nichesCurrentPage === this.nichesTotalPages && (this.enough = true);
      } else if (this.nichesCurrentPage === this.nichesTotalPages) this.enough = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 1.8em;
}
.grouper-subtitle {
  width: 100%;
  min-height: 100%;
  height: auto;
  padding: 0;
  font-weight: 400;
  line-height: 1.5;
  font-size: 28.8px;
}
</style>
